import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'alert-already-connected',
  standalone: true,
  imports: [],
  templateUrl: './alert-already-connected.component.html',
  styleUrl: './alert-already-connected.component.scss'
})
export class AlertAlreadyConnectedComponent {

  @Input() platform: { title: string, icon: string, action: string } | undefined;
  @Output() close = new EventEmitter<void>();

  closeAlert() {
    this.close.emit();
  }

}
